// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a8ee","col":"styles_col__14GCA"};